<template>
  <div>
    <slot />
  </div>
</template>

<script setup lang="ts">
import { provide, ref } from 'vue';

interface Props {
  open?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  open: false,
});

const isOpen = ref(props.open);
const toggle = () => {
  isOpen.value = !isOpen.value;
};

provide('isOpen', isOpen);
provide('toggle', toggle);
</script>
